import Card from "@material-ui/core/Card";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { changeAppState } from "../../../../common/appState";
import { appsPublicImg } from "../../../../common/consts";
import { spaceBetween } from "../../../../common/util/Array/spaceBetween";
import { User } from "../../../shared/User/types";

export function ChakraCard({
    scrollingDown,
    isFooterShown,
    user,
    isUserFetchDone,
}: {
    scrollingDown: boolean;
    isFooterShown: boolean;
    user: User | undefined;
    isUserFetchDone: boolean;
}) {
    const c = useChakraStyles({ scrollingDown, isFooterShown });

    const handleClick = () => {
        if (!user) {
            changeAppState("signInPanelState", { type: "signIn" });
            return;
        }
        changeAppState("chakraPurchasePanelState", { open: true });
    };

    return (
        <Card
            className={spaceBetween(
                c.card,
                isUserFetchDone ? "opacity1" : "opacity0",
                "t1s"
            )}
            onClick={handleClick}
        >
            <img
                src={`${appsPublicImg}system/chakra.png`}
                className={c.chakraImg}
            />
            <span className={c.chakraNumber}>
                {(user?.chakra || 0).toLocaleString()}
            </span>
            Chakra
        </Card>
    );
}

const useChakraStyles = makeStyles<
    Theme,
    { scrollingDown: boolean; isFooterShown: boolean }
>(theme => ({
    card: ({ scrollingDown, isFooterShown }) => ({
        position: "absolute",
        top: isFooterShown ? (scrollingDown ? -37 : -71) : 0,
        height: 35,
        left: -5,
        display: "flex",
        alignItems: "center",
        paddingRight: 10,
        fontSize: "medium",
        cursor: "pointer",
    }),
    chakraImg: {
        width: 30,
        height: 30,
        marginRight: 8,
        marginLeft: 10,
        marginBottom: 1,
        objectFit: 'contain',
        objectPosition: 'center',
    },
    chakraNumber: {
        fontSize: "large",
        color: theme.palette.primary.main,
        marginRight: 8,
        fontWeight: "bold",
    },
}));
